// extracted by mini-css-extract-plugin
export default {"icon":"icon___gCZDC"};